import {
    AutoAttachmentSourceSubType,
    type AutoAttachmentDto,
} from '../../types/customerFollowUp/autoAttachment';

const stripExtension = (name: string): string => name.replace(/\.[^.]+$/, '');

// Category is derived purely from sourceSubType — the backend stamps each row with
// STATEOFACCOUNT, INVOICE, or CREDIT, so no filename inspection (and therefore no
// FR/EN prefix table) is required on the frontend.
const getCategory = (attachment: AutoAttachmentDto): number => {
    if (attachment.sourceSubType === AutoAttachmentSourceSubType.STATEOFACCOUNT) return 0;
    if (attachment.sourceSubType === AutoAttachmentSourceSubType.INVOICE) return 1;
    if (attachment.sourceSubType === AutoAttachmentSourceSubType.CREDIT) return 2;
    return 3;
};

// Auto-attached invoice/credit filenames follow "{Prefix} {Number}.pdf" (e.g.
// "Facture 2024-001.pdf", "Invoice 2024-001.pdf", "Crédit 2024-002.pdf",
// "Credit Note 2024-002.pdf"). Splitting on the first space yields the trailing
// document number language-agnostically. Filenames without a space (custom or
// unprefixed names) fall back to sorting by their full stem.
const getDocumentNumber = (fileName: string): string => {
    const stem = stripExtension(fileName);
    const firstSpace = stem.indexOf(' ');
    return firstSpace >= 0 ? stem.slice(firstSpace + 1) : stem;
};

export const sortAutoAttachments = (attachments: AutoAttachmentDto[]): AutoAttachmentDto[] => {
    return [...attachments].sort((a, b) => {
        const categoryDiff = getCategory(a) - getCategory(b);
        if (categoryDiff !== 0) return categoryDiff;
        return getDocumentNumber(a.fileName).localeCompare(
            getDocumentNumber(b.fileName),
            undefined,
            { numeric: true, sensitivity: 'base' }
        );
    });
};
